export default {
      id: "ic-para-link-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-para-link-usage",
      toString: function () {
        return this.url;
      }
    }